<template>
  <div>
    <zj-layout-container>
      <zj-layout-main>
        <div class="zj-layout-main-content bgcolor scrollable">
          设备管理
        </div>
      </zj-layout-main>
    </zj-layout-container>
  </div>
</template>

<script>
export default {
  name: 'ZjEquipmentHome',
  controller: 'UI',
  action: 'Home'
}  
</script>
